import { lazy } from "react";
import Loadable from "app/components/Loadable";

const OfficeLocationMappingList = Loadable(
  lazy(() => import("./OfficeLocationMappingList")),
);
const OfficeLocationMappingEdit = Loadable(
  lazy(() => import("./OfficeLocationMappingAdd")),
);

const OfficeLocationMappingRoutes = [
  {
    path: "/ems/office/location/mapping",
    element: <OfficeLocationMappingList />,
  },
  {
    path: "/ems/office/location/mapping/:mode/:id",
    element: <OfficeLocationMappingEdit />,
  },
];

export default OfficeLocationMappingRoutes;
